import React from 'react';
import { FaCheck, FaTimes, FaExclamationTriangle } from 'react-icons/fa';

const ConfirmTooltip = ({ show, onConfirm, onCancel, children }) => {
  if (!show) return null;

  return (
    <div 
      className="position-absolute bg-white border rounded-3 shadow-lg p-3"
      style={{
        bottom: 'calc(100% + 10px)',
        left: 0,
        width: '300px',
        maxWidth: '90vw',
        zIndex: 10,
        animation: 'tooltip-fade-in 0.2s ease-out'
      }}
    >
      <style>{`
        @keyframes tooltip-fade-in {
          from { opacity: 0; transform: translateY(5px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
      <div className="d-flex align-items-start gap-3">
        <div className="text-warning mt-1">
          <FaExclamationTriangle size={20} />
        </div>
        <div>
          <p className="fw-semibold text-dark mb-2" style={{ fontSize: '0.9rem' }}>
            {children}
          </p>
          <div className="d-flex gap-2 mt-3">
            <button 
              type="button" 
              className="btn btn-sm btn-danger d-flex align-items-center gap-2 flex-grow-1" 
              onClick={onConfirm}
            >
              <FaCheck /> Yes, Delete
            </button>
            <button 
              type="button" 
              className="btn btn-sm btn-light border flex-grow-1" 
              onClick={onCancel}
            >
              <FaTimes /> Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmTooltip;